import LoadingSpinner from 'components/spinners/LoadingSpinner';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RequestStatus, useApiCallFn } from 'hooks/useApiCallFn';
import { useUserConfirmUserEmailHook } from 'api/user/user';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ReconfirmEmailPage: React.FC = () => {
  const queryParams = useQuery();
  const b64EmailConfirmToken = queryParams.get('emailConfirmToken');
  const userId = queryParams.get('userId');

  const confirmUserEmail = useUserConfirmUserEmailHook();

  const confirmEmailCall = useApiCallFn(
    (usrId: number, emailToken: string) =>
      confirmUserEmail({ userId: usrId, emailConfirmToken: emailToken })
  );

  useEffect(() => {
    if (
      userId &&
      b64EmailConfirmToken &&
      confirmEmailCall.status === RequestStatus.Idle
    ) {
      confirmEmailCall.run(Number(userId), window.atob(b64EmailConfirmToken));
    }
  }, [confirmEmailCall, b64EmailConfirmToken, userId]);

  if (confirmEmailCall.status !== RequestStatus.Fetched) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <h1>Tack!</h1>
      <p>Din nya e-postadress är nu redo att användas.</p>
    </>
  );
};

export default ReconfirmEmailPage;
